module.exports = __webpack_public_path__ + "assets/1d100be74e086889df784b6fb4589230.png";